const reviews = [
    {
        nameKey: "customer.name.evan",
        totalFiles: 12,
        mark: 5,
        messageKey: "customer.review.evan"
    },
    {
        nameKey: "customer.name.omer",
        totalFiles: 49,
        mark: 5,
        messageKey: "customer.review.omer"
    },
    {
        nameKey: "customer.name.gillian",
        totalFiles: 22,
        mark: 4,
        messageKey: "customer.review.gillian"
    },
    {
        nameKey: "customer.name.tom",
        totalFiles: 42,
        mark: 5,
        messageKey: "customer.review.tom"
    },
    {
        nameKey: "customer.name.nathalie",
        totalFiles: 420,
        mark: 5,
        messageKey: "customer.review.nathalie"
    },
    {
        nameKey: "customer.name.charlotte",
        totalFiles: 69,
        mark: 5,
        messageKey: "customer.review.charlotte"
    },
    {
        nameKey: "customer.name.marcelin",
        totalFiles: 123,
        mark: 5,
        messageKey: "customer.review.marcelin"
    }
]

export const getNewIndex = (index) => {
    return ((index % reviews.length) + reviews.length) % reviews.length;
}

export const getReview = (index) => {
    return reviews[getNewIndex(index)];
}